import React, {useMemo} from "react";
import styled from "styled-components";
import {Pagination} from "@material-ui/lab";
import {limit} from "../../net/http_server";

export interface PaginatInterface {
    total: number,
    setPage: Function
}

export const PageInatWidegt: React.FC<PaginatInterface> = ({total, setPage}) => {
    const count = useMemo<number>(() => Math.ceil(total / limit), [total])

    return (
        <PaginationStyle>
            <Pagination count={count} color="primary"
                        variant="outlined"
                        onChange={(ev, index) => {
                            setPage(index)
                        }} shape="rounded"/>
        </PaginationStyle>
    );
}


const PaginationStyle = styled.div`
  display: flex;
  justify-content: flex-end;

  > .MuiPagination-root {
    padding: 10px 5%;
  }
`
